export interface Translation {
    translations_key: string;
    languages_locale: string;
    value: string;
}

export const isTranslation = (obj: unknown): obj is Translation => {
    return (
        typeof obj === 'object' &&
        !!obj &&
        'translations_key' in obj &&
        typeof obj.translations_key === 'string' &&
        'languages_locale' in obj &&
        typeof obj.languages_locale === 'string' &&
        'value' in obj &&
        typeof obj.value === 'string'
    );
};
